"use client";
import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import BeatLoader from "react-spinners/BeatLoader";
import Image from "next/image";
import { message } from "antd";
import { Store, UpdateStore } from "../../StoreContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import LocationInputs from "./LocationInputs";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Hours from "../data/Hours.json";
import style from "@/app/style/state.module.css";
import { GoogleMap, Marker, DirectionsRenderer } from "@react-google-maps/api";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import TimePicker from "./TimePicker";
import Info from "../../../public/updated-home/hero-section/info.svg";
import dayjs from "dayjs";
import Skeleton from "@mui/material/Skeleton";
import { InputAdornment, IconButton } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";

import {
  LocalizationProvider,
  DatePicker as MuiDatePicker,
  TimePicker as MuiTimePicker,
} from "@mui/x-date-pickers";
import { initialStoreState } from "@/initialState";

const center = { lat: 40.6413, lng: -73.7781 }; // center for map

const minDate = dayjs(new Date());

// function loadScript(src, position, id) {
//   if (!position) {
//     return;
//   }
//   // Check if the script is already present on the page
//   const existingScript = document.getElementById(id);
//   if (existingScript) {
//     return; // If the script is already present, do nothing
//   }
//   // Create a new script element
//   const script = document.createElement("script");
//   script.setAttribute("async", "");
//   script.setAttribute("id", id);
//   script.src = src;
//   // Handle errors during script loading
//   script.onerror = () => {
//     console.error(`Failed to load script: ${src}`);
//   };
//   // Append the script to the specified position (usually the <head> tag)
//   position.appendChild(script);
// }

function homepage({ image, title, subtitle }) {
  // const googleApiKey = process.env.NEXT_PUBLIC_API_KEY;
  // console.log(googleApiKey,'googleApiKey....')
  const [waitTime, setWaitTime] = useState(25);
  const router = useRouter();
  const updateStore = UpdateStore();
  const store = Store();
  // console.log(store,'Store')

  const { originalPoint } = store;
  const [messageApi, contextHolder] = message.useMessage();

  const [isPointToPointHire, setIsPointToPointHire] = useState(true);
  const [loading, setLoading] = useState(null);
  const [addStopArray, setAddStopArray] = useState([]);

  const [pickupValue, setPickupValue] = useState(null);
  const [pickupInputValue, setPickupInputValue] = useState("");
  const [pickupOptions, setPickupOptions] = useState([]);
  const [pickupError, setPickupError] = useState(false);

  const [dropoffValue, setDropoffValue] = useState(null);
  const [dropoffInputValue, setDropoffInputValue] = useState("");
  const [dropoffOptions, setDropoffOptions] = useState([]);
  const [dropoffError, setDropoffError] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [dateError, setDateError] = useState(false);
  const [timeError, setTimeError] = useState(false);
  const [dateTimeMsg, setDateTimeMsg] = useState("");

  const [inputClick, setInputClick] = useState(false);
  const [selectedHour, setSelectedHour] = useState(12); // Initial hour value
  const [selectedMinute, setSelectedMinute] = useState(0); // Initial minute value
  const [isAM, setIsAM] = useState(true); // Initial AM/PM value

  const [hour, setHour] = useState(Hours[0]);
  const [inputHour, setInputHour] = useState("");

  const [map, setMap] = useState(/** @type google.maps.Map */ (null));
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");

  const loaded = useRef(false);
  const autocompleteService = useRef(null);
  const [showMap, setShowMap] = useState(false);
  const [hourlyMsg, setHourlyMsg] = useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false); // Track if the API is loaded

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     // Check if Google Maps is already loaded
  //     if (window.google && window.google.maps && window.google.maps.places) {
  //       // If loaded, directly initialize the AutocompleteService
  //       autocompleteService.current =
  //         new window.google.maps.places.AutocompleteService();
  //       loaded.current = true;
  //       setShowMap(true);
  //       setIsLoaded(true); // Enable input once API is loaded
  //     } else {
  //       // Declare the callback function in the global scope
  //       window.onGoogleMapsLoad = () => {
  //         if (
  //           window.google &&
  //           window.google.maps &&
  //           window.google.maps.places
  //         ) {
  //           autocompleteService.current =
  //             new window.google.maps.places.AutocompleteService();
  //           loaded.current = true;
  //           setShowMap(true);
  //           setIsLoaded(true); // Enable input once API is loaded
  //         } else {
  //           console.error("Google Maps API failed to load properly.");
  //         }
  //       };
  //       if (!loaded.current && !document.querySelector("#google-maps")) {
  //         // Reset loaded.current to false when the component unmounts and mounts again
  //         loaded.current = false;
  //         // Load the script only if it hasn't been loaded yet
  //         loadScript(
  //           `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places&callback=onGoogleMapsLoad`,
  //           document.querySelector("head"),
  //           "google-maps"
  //         );
  //       }
  //     }
  //   }
  //   return () => {
  //     loaded.current = false;
  //   };
  // }, []);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  useEffect(() => {
    updateStore(initialStoreState);
  }, []);

  const openMessage = ({ msg }) => {
    messageApi.open({
      key: "updatable",
      type: "error",
      content: msg,
      duration: 2,
    });
  };

  // Effect to get values from local storage when the component mounts
  useEffect(() => {
    // Check if localStorage is available (client side)
    if (typeof window !== "undefined" && image !== "master-page") {
      // Token ko temporarily save karo
      const token = localStorage.getItem("token");

      // localStorage ko clear karo
      localStorage.clear();

      // Token ko wapas set karo
      if (token) {
        localStorage.setItem("token", token);
      }
      return;
    }
    if (typeof window !== "undefined" && image === "master-page") {
      // Use localStorage as needed
      const storedIsPointToPointHire =
        localStorage.getItem("isPointToPointHire");
      if (storedIsPointToPointHire !== null)
        setIsPointToPointHire(JSON.parse(storedIsPointToPointHire));

      const storedPickupValue = localStorage.getItem("pickupValue");
      if (storedPickupValue !== null)
        setPickupValue(JSON.parse(storedPickupValue));

      const storedPickupInputValue = localStorage.getItem("pickupInputValue");
      if (storedPickupInputValue !== null)
        setPickupInputValue(JSON.parse(storedPickupInputValue));

      const storedDropoffValue = localStorage.getItem("dropoffValue");
      if (storedDropoffValue !== null)
        setDropoffValue(JSON.parse(storedDropoffValue));

      const storedDropoffInputValue = localStorage.getItem("dropoffInputValue");
      if (storedDropoffInputValue !== null)
        setDropoffInputValue(JSON.parse(storedDropoffInputValue));

      const hour = localStorage.getItem("hour");
      if (hour !== null) setHour(JSON.parse(hour));

      const inputHour = localStorage.getItem("inputHour");
      if (inputHour !== null) setInputHour(JSON.parse(inputHour));

      const storedDate = localStorage.getItem("selectedDate");
      if (storedDate !== null) {
        const parsedDate = JSON.parse(storedDate);
        // Check if the parsedDateTime is a valid DateTime object
        if (dayjs(parsedDate).isValid()) {
          setSelectedDate(dayjs(parsedDate));
        } else {
          // Handle the case where the stored DateTime is not valid
          console.error("Invalid Date stored in localStorage");
        }
      }

      const inputClick = localStorage.getItem("inputClick");
      if (inputClick) {
        setInputClick(JSON.parse(inputClick));
      }
      const storedHour = localStorage.getItem("selectedHour");
      console.log(storedHour, "dddd");
      if (storedHour !== null) {
        setSelectedHour(JSON.parse(storedHour));
      }
      const storedMinute = localStorage.getItem("selectedMinute");
      if (storedMinute !== null) {
        setSelectedMinute(JSON.parse(storedMinute));
      }
      const storedAM = localStorage.getItem("isAM");
      if (storedAM !== null) {
        setIsAM(JSON.parse(storedAM));
      }

      const addStops = localStorage.getItem("addStopArray");
      if (addStops !== null) setAddStopArray(JSON.parse(addStops));
    }
  }, [image]);

  // Effect to set pickupValue to local storage when it changes
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (pickupValue !== null) {
        localStorage.setItem("pickupValue", JSON.stringify(pickupValue));
        if (pickupValue?.types?.includes("airport")) {
          setWaitTime(60);
        } else {
          setWaitTime(25);
        }

        localStorage.setItem(
          "pickupInputValue",
          JSON.stringify(pickupInputValue)
        );
        localStorage.setItem("returndropoffValue", JSON.stringify(pickupValue));
        localStorage.setItem(
          "returndropoffInputValue",
          JSON.stringify(pickupInputValue)
        );
      } else {
        // If pickupValue is set to null, remove it from local storage
        setWaitTime(25);
        localStorage.removeItem("pickupValue");
        localStorage.removeItem("pickupInputValue");
        localStorage.removeItem("returndropoffValue");
        localStorage.removeItem("returndropoffInputValue");
      }
      if (dropoffValue !== null) {
        localStorage.setItem("dropoffValue", JSON.stringify(dropoffValue));
        localStorage.setItem(
          "dropoffInputValue",
          JSON.stringify(dropoffInputValue)
        );
        localStorage.setItem("returnpickupValue", JSON.stringify(dropoffValue));
        localStorage.setItem(
          "returnpickupInputValue",
          JSON.stringify(dropoffInputValue)
        );
      } else {
        // If dropoffValue is set to null, remove it from local storage
        localStorage.removeItem("dropoffValue");
        localStorage.removeItem("dropoffInputValue");
        localStorage.removeItem("returnpickupValue");
        localStorage.removeItem("returnpickupInputValue");
      }
      if (selectedDate !== null) {
        localStorage.setItem("selectedDate", JSON.stringify(selectedDate));
      } else {
        localStorage.removeItem("selectedDate");
      }
      if (addStopArray.length > 0) {
        const array = addStopArray.filter((stop) => stop?.location != null);
        if (array.length > 0) {
          localStorage.setItem("addStopArray", JSON.stringify(array));
          localStorage.setItem("returnaddStopArray", JSON.stringify(array));
        } else {
          localStorage.removeItem("addStopArray");
          localStorage.removeItem("returnaddStopArray");
        }
      } else {
        localStorage.removeItem("addStopArray");
        localStorage.removeItem("returnaddStopArray");
      }
    }
  }, [pickupValue, dropoffValue, selectedDate, addStopArray]);

  useEffect(() => {
    if (pickupValue) {
      setPickupError(false);
    }
    if (dropoffValue) {
      setDropoffError(false);
    }
    if (selectedDate) {
      setDateError(false);
    }
    if (inputClick) {
      setTimeError(false);
    }
  }, [pickupValue, dropoffValue, selectedDate, inputClick]);

  useEffect(() => {
    if (loading === true) {
      router.push("/booking/vehicle");
    } else if (
      loading === false &&
      distance !== "" &&
      parseFloat(distance) !== 0
    ) {
      HandleSubmit(); // Call HandleSubmit function when distance is available
    }
  }, [loading, distance]);

  useEffect(() => {
    if (
      (pickupValue && dropoffValue && showMap) ||
      (pickupValue &&
        showMap &&
        addStopArray.length > 0 &&
        addStopArray.some((stop) => stop?.location))
    ) {
      calculateRoute();
    } else {
      setDirectionsResponse(null);
      setDistance("");
      setDuration("");
      // setShowMap(false);
    }
  }, [pickupValue, dropoffValue, addStopArray, showMap]);

  const calculateRoute = async () => {
    // console.log('Calculating route...');
    // console.log('Pickup:', pickupInputValue);
    // console.log('Dropoff:', dropoffInputValue, addStopArray);
    setDistance("");
    setDuration("");

    try {
      let addStopWaypoints = [];

      if (addStopArray.length > 0) {
        addStopWaypoints = addStopArray
          .filter((stop) => stop?.location)
          .map((stop) => ({
            location: stop.inputValue,
            stopover: true, // This indicates that it's a stop, not just a waypoint
          }));
      }
      // console.log(addStopWaypoints, 'stoppoints');
      const directionsService = new google.maps.DirectionsService();
      const lastStopIndex = addStopWaypoints.length - 1;

      const results = await directionsService.route({
        origin: pickupInputValue,
        destination: dropoffInputValue
          ? dropoffInputValue
          : addStopWaypoints[lastStopIndex]?.location,
        waypoints: !dropoffInputValue
          ? addStopWaypoints.slice(0, lastStopIndex)
          : addStopWaypoints, // Use all stops except the last one
        travelMode: google.maps.TravelMode.DRIVING,
        drivingOptions: {
          departureTime: new Date(),
          trafficModel: "bestguess",
        },
      });

      console.log("Results:", results);

      setDirectionsResponse(results);
      if (results) {
        let total = 0;
        let durationArray = [];
        results.routes[0].legs.map((obj) => {
          // Remove 'mi' unit, remove commas, and convert to a number
          const distanceWithoutUnitAndCommas = +obj.distance.text
            .replace(/,/g, "")
            .replace(" mi", "");

          // Add the cleaned distance to the total
          if (!isNaN(distanceWithoutUnitAndCommas)) {
            total += distanceWithoutUnitAndCommas;
          }
          // total += parseFloat(obj.distance.text);
          durationArray.push(obj.duration.text);
        });
        const miles = parseFloat(total?.toFixed(2)) + " mi";
        // console.log(miles,'milessssss');
        setDistance(miles);

        // Initialize total hours and total minutes to 0
        let totalHours = 0;
        let totalMinutes = 0;

        // Function to convert duration strings to hours and minutes
        const convertDurationToHoursAndMinutes = (durationString) => {
          const parts = durationString.split(" "); // Split the string by space
          let hours = 0;
          let minutes = 0;
          let days = 0;

          // Check for days, hours, and minutes in the string
          for (let i = 0; i < parts.length; i++) {
            if (parts[i] === "day" || parts[i] === "days") {
              days = parseInt(parts[i - 1]) || 0; // Get the number of days
            } else if (parts[i] === "hour" || parts[i] === "hours") {
              hours = parseInt(parts[i - 1]) || 0; // Get the number of hours
            } else if (parts[i] === "min" || parts[i] === "mins") {
              minutes = parseInt(parts[i - 1]) || 0; // Get the number of minutes
            }
          }

          // Convert days to hours
          totalHours += days * 24 + hours;
          totalMinutes += minutes;
        };

        // Loop through the duration strings and convert them to total hours and minutes
        durationArray.forEach((durationString) => {
          convertDurationToHoursAndMinutes(durationString);
        });

        // Loop through the duration strings and add hours and minutes to the totals
        // durationArray.forEach((durationString) => {
        //   const parts = durationString.split(" "); // Split the string by space
        //   // console.log(parts,'parts');
        //   if (parts.length === 4) {
        //     // If the string has the format "X hour Y mins"
        //     const hours = parseInt(parts[0]); // Parse hours
        //     const minutes = parseInt(parts[2]); // Parse minutes
        //     totalHours += hours;
        //     totalMinutes += minutes;
        //   } else if (parts.length === 2 && parts[1] === "mins") {
        //     // If the string has the format "Y mins"
        //     const minutes = parseInt(parts[0]); // Parse minutes
        //     totalMinutes += minutes;
        //   }
        // });

        // Adjust total hours and minutes if necessary
        if (totalMinutes >= 60) {
          const extraHours = Math.floor(totalMinutes / 60);
          totalHours += extraHours;
          totalMinutes = totalMinutes % 60;
        }

        // console.log(`Total time: ${totalHours} hours ${totalMinutes} mins`);
        const time = `${totalHours} hours ${totalMinutes} mins`;
        setDuration(time);
      }
    } catch (error) {
      console.error("Error calculating route:", error);
    }
  };

  // Function to add a new stop
  const addStop = () => {
    if (isPointToPointHire && addStopArray.length === 3) {
      setHourlyMsg(true);
      return;
    } else {
      setHourlyMsg(false);
    }
    if (addStopArray.length > 0) {
      const lastStopIndex = addStopArray.length - 1;
      if (!addStopArray[lastStopIndex].location) {
        // Update the existing stop with error flag set to true
        setAddStopArray((prev) => [
          ...prev.slice(0, lastStopIndex), // Keep previous stops unchanged
          { ...prev[lastStopIndex], error: true }, // Update the last stop with error flag
        ]);
        return;
      }
    }

    // Add a new stop
    setAddStopArray((prev) => [
      ...prev,
      {
        location: null,
        inputValue: "",
        options: [],
        time: "",
        error: false,
      },
    ]);

    setHourlyMsg(false);
    // setShowMap(false);
  };

  const deleteStopAtIndex = (index) => {
    setAddStopArray((prev) => prev.filter((_, i) => i !== index));
    // setTimeout(() => {
    //   setShowMap(true);
    // }, 100);
  };

  const handleDeleteStop = (index) => {
    // Call the function to delete the stop at the specified index
    deleteStopAtIndex(index);
  };

  const handleChange = (event, newValue, type, index) => {
    // if (type === "stop" && !newValue) {
    //   setShowMap(false);
    // } else {
    //   setShowMap(true);
    // }
    if (type === "pickUp") {
      // setPickupOptions(newValue ? [newValue, ...pickupOptions] : pickupOptions);
      setPickupValue(newValue);
    } else if (type === "dropOff") {
      // setDropoffOptions(
      //   newValue ? [newValue, ...dropoffOptions] : dropoffOptions
      // );
      setDropoffValue(newValue);
    } else if (type === "stop") {
      setAddStopArray((prev) =>
        prev.map((stop, i) =>
          i === index ? { ...stop, location: newValue } : stop
        )
      );
    }
  };

  const handleInputChange = (event, newInputValue, type, index) => {
    if (type === "pickUp") {
      setPickupInputValue(newInputValue);
    } else if (type === "dropOff") {
      setDropoffInputValue(newInputValue);
    } else if (type === "stop") {
      setStopInputValueAtIndex(newInputValue, index);
    }
  };

  const setStopInputValueAtIndex = (newInputValue, index) => {
    setAddStopArray((prev) =>
      prev.map((stop, i) =>
        i === index
          ? { ...stop, inputValue: newInputValue, error: false }
          : stop
      )
    );
  };

  const checkValidation = () => {
    let valid = true;
    if (!pickupValue) {
      setPickupError(true);
      valid = false;
    }
    if (isPointToPointHire && !dropoffValue) {
      setDropoffError(true);
      valid = false;
    }

    if (!inputClick) {
      setTimeError(true);
      valid = false;
    }

    if (!selectedDate) {
      setDateError(true);
      valid = false;
    }
    if (selectedDate) {
      // Get the current date and time
      const currentDateTime = new Date();

      // Add 3 hours to the current date and time
      const minimumDateTime = new Date(
        currentDateTime.getTime() + 3 * 60 * 60 * 1000
      );

      // Combine selected date and time
      // const selectedDateTime = new Date(selectedDate);
      // selectedDateTime.setHours(
      //   selectedHour +
      //     (isAM && selectedHour === 12
      //       ? -12
      //       : !isAM && selectedHour !== 12
      //       ? 12
      //       : 0)
      // );
      // selectedDateTime.setMinutes(selectedMinute);

      const selectedDateTime = new Date(selectedDate);
      // Convert selectedHour to a 24-hour format
      if (isAM) {
        if (selectedHour === 12) {
          selectedDateTime.setHours(0); // 12 AM is 00:00 in 24-hour format
        } else {
          selectedDateTime.setHours(selectedHour); // Keep the hour as is for AM
        }
      } else {
        if (selectedHour === 12) {
          selectedDateTime.setHours(12); // 12 PM remains 12:00
        } else {
          selectedDateTime.setHours(selectedHour + 12); // Convert PM hour to 24-hour format
        }
      }

      // console.log(selectedDateTime, "dddd", minimumDateTime);

      // Check if the selected date and time is at least 3 hours ahead
      const isValidDateTime = selectedDateTime >= minimumDateTime;
      // console.log(isValidDateTime, "fffffffff");
      if (!isValidDateTime) {
        setDateTimeMsg(
          "Reservations are disallowed less than 3 hour(s) before trip time."
        );
        valid = false;
      } else {
        setDateTimeMsg("");
      }
    }
    // if (addStopArray.length > 0) {
    //   addStopArray.forEach((stop) => {
    //     if (!stop.location) {
    //       stop.error = true;
    //       valid = false;
    //     }
    //   });
    //   setAddStopArray([...addStopArray]); // Update the state of the array
    // }

    if (addStopArray.length > 0) {
      let hasError = false;

      const updatedStops = addStopArray.map((stop) => {
        if (!stop.location) {
          hasError = true;
          valid = false;
          return { ...stop, error: true };
        }
        return stop;
      });

      if (hasError) {
        setAddStopArray(updatedStops); // 🔁 Update only if any error exists
      }
    }

    if (
      pickupInputValue &&
      dropoffInputValue &&
      pickupInputValue === dropoffInputValue &&
      isPointToPointHire
    ) {
      const hasStops = addStopArray?.length > 0;
      const hasDifferentStop = addStopArray?.some(
        (stop) => stop?.inputValue && stop?.inputValue !== pickupInputValue
      );

      // ✅ Only valid if at least one stop is different
      valid = hasStops && hasDifferentStop;
      if (!(hasStops && hasDifferentStop)) {
        openMessage({
          msg: "Pickup and drop-off locations cannot be the same. Please book an hourly reservation.",
        });
      }
    }

    // if (addStopArray.length > 0) {
    //   const lastStopIndex = addStopArray.length - 1;
    //   if (!addStopArray[lastStopIndex].location) {
    //     addStopArray[lastStopIndex].error = true;
    //     valid = false;
    //   }
    //   setAddStopArray([...addStopArray]); // Update the state of the array
    // }

    if (!isPointToPointHire && addStopArray.length === 0) {
      setHourlyMsg(true);
      valid = false;
    }

    if (isPointToPointHire) {
      setHourlyMsg(false);
    }

    return valid;
  };

  const HandleSubmit = async () => {
    const { coordinates } = store;
    let result = await checkValidation();
    // let result = true;
    console.log(result, "result");
    if (result === true) {
      let stopStates = [];
      if (addStopArray.length > 0) {
        stopStates = addStopArray
          .filter((stop) => stop?.location)
          .map((stop) => ({
            address: stop.inputValue,
            time: 15,
            type: "stops",
          }));
      }

      const mainData = {
        isPointToPointHire,
        pickUpLocation: pickupInputValue,
        dropOffLocation: dropoffInputValue,
        stops: stopStates,
        hour: +hour.split(" ")[0],
        // selectedTime: selectedDateTime?.format("h:mm A"),
        selectedTime: `${selectedHour
          ?.toString()
          .padStart(2, "0")}:${selectedMinute?.toString().padStart(2, "0")} ${
          isAM ? "AM" : "PM"
        }`,
        selectedDate: selectedDate?.format("ddd, MMM DD[th], YYYY"),
        // selectedDate: selectedDateTime?.format("ddd, MMM DD[th], YYYY"),
        totalDistance: parseFloat(distance?.replace(" mi", "")),
        totalDuration: duration,
      };

      const coordinatesData = {
        pickUp: pickupValue,
        dropOff: dropoffValue,
        pickUpLocation: pickupInputValue,
        dropOffLocation: dropoffInputValue,
        stops: addStopArray,
      };
      // console.log(stopStates, 'stopStates');
      updateStore({
        originalPoint: {
          ...originalPoint,
          OriginalReservation: mainData,
        },
        coordinates: {
          ...coordinates,
          ...coordinatesData,
        },
      });

      if ((!distance || parseFloat(distance) === 0) && isPointToPointHire) {
        setLoading(false);
        // return
      } else {
        // Storing the object in localStorage
        localStorage.setItem("originalPointData", JSON.stringify(mainData));
        localStorage.setItem(
          "coordinatesData",
          JSON.stringify(coordinatesData)
        );
        setLoading(true);
      }
    }
  };

  return (
    <>
      {contextHolder}
      <div className="font-inter">
        <div className="mx-auto max-w-7xl headerpxset">
          <div
            className={
              image === "master-page" || image === "homepage"
                ? "mapdiv"
                : "mainheadersize"
            }
          >
            {(pickupValue && dropoffValue && showMap) ||
            (pickupValue &&
              showMap &&
              addStopArray.length > 0 &&
              addStopArray.some((stop) => stop?.location)) ? (
              <GoogleMap
                center={center}
                zoom={15}
                mapContainerStyle={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "20px",
                }}
                options={{
                  zoomControl: false,
                  streetViewControl: false,
                  mapTypeControl: false,
                  fullscreenControl: false,
                }}
                onLoad={(map) => setMap(map)}
              >
                {/* {directionsResponse && <Marker position={center} />} */}

                {directionsResponse && (
                  <DirectionsRenderer
                    options={{
                      polylineOptions: {
                        strokeColor: "#2B3252",
                        strokeOpacity: 0.7,
                        strokeWeight: 3,
                      },
                    }}
                    directions={directionsResponse}
                  />
                )}
                {directionsResponse && (
                  <div
                    style={{
                      position: "absolute",
                      background: "white",
                      zIndex: 100,
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      bottom: "10px",
                      left: "10px",
                    }}
                  >
                    <p>Distance: {distance}</p>
                    <p>Duration: {duration}</p>
                  </div>
                )}
              </GoogleMap>
            ) : (
              <div
                id={
                  image !== "master-page" && image !== "homepage"
                    ? style.mainheadersize
                    : ""
                }
                className={style[image]}
              >
                {image === "homepage" && (
                  <div className=" mb-8 max-w-7xl  pl-6 sm:pl-4 md:pl-5 lg:pl-10">
                    <p className="welco     rounded-md">
                      Welcome to Prestige Ride
                    </p>
                    <h1 className="newhomefont2">
                      The Future of <br />
                      <span className="newhomefont1 ">Black Car Service</span>
                    </h1>
                  </div>
                )}

                {image === "master-page" && (
                  <div className="item  display col-span-5 pt-96 mb-8 max-w-7xl  pl-6 sm:pl-4 md:pl-5 lg:pl-10">
                    <h1 className="newhomefont2 secondary">
                      Book your <br />
                      <span className="newhomefont1 secondary">
                        LUXURY TRANSFER
                      </span>
                    </h1>
                  </div>
                )}

                {image !== "master-page" && image !== "homepage" && (
                  <div className=" mb-8 max-w-3xl  pl-6 sm:pl-4 md:pl-5 lg:pl-10">
                    <h1 className="serviceh1">
                      <span className="">{subtitle}</span>
                      <span className="text-[#D5AF34] ">{title}</span>{" "}
                    </h1>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className=" grid grid-cols-1   sm:grid-cols-1 md:grid-cols-1  lg:grid-cols-2">
            <div className=" display-laptop lg:display-desktop  display  "></div>

            <div
              className={`lg:max-w-3xl  ${
                image !== "master-page" && image !== "homepage"
                  ? "lg:pt-11 updateform2"
                  : "updateform"
              }  order-3 md:order-none`}
            >
              <div className="master-shadow  relative lg:rounded-3xl bg-white ">
                <div className="text-center  flex justify-between p-0">
                  <div
                    className={`label-form font0 ${
                      isPointToPointHire ? "" : "point-to-pintborder"
                    } w-1/2  pt-3  pl-2 pr-10 px-1 cursor-pointer lg:rounded-tl-3xl`}
                    onClick={() => {
                      setIsPointToPointHire(true);
                      setHourlyMsg(false);
                      if (typeof window !== "undefined") {
                        localStorage.setItem(
                          "isPointToPointHire",
                          JSON.stringify(true)
                        );
                      }
                    }}
                  >
                    POINT TO POINT
                  </div>
                  <div
                    className={`label-form font0 ${
                      !isPointToPointHire ? "" : "point-to-pintborder"
                    } w-1/2 pt-3 px-1 cursor-pointer xl:rounded-tr-3xl`}
                    onClick={() => {
                      setIsPointToPointHire(false);
                      setHourlyMsg(false);
                      setDropoffValue(null);
                      setDropoffInputValue("");

                      if (typeof window !== "undefined") {
                        localStorage.setItem(
                          "isPointToPointHire",
                          JSON.stringify(false)
                        );
                      }
                    }}
                  >
                    HOURLY HIRE
                  </div>
                </div>
                <div className=" px-4 pt-4 grid grid-cols-1 gap-2">
                  <div>
                    <label
                      htmlFor="pickup-location"
                      className="block label-form fontsmall"
                    >
                      Pick-up Location
                    </label>

                    {/* {!isLoaded ? (
                    // Show skeleton loader while the API is loading
                    <Skeleton
                      variant="rectangular"
                      height={56}
                      sx={{ borderRadius: 1 }}
                    />
                  ) : ( */}
                    <LocationInputs
                      id="pickup-location"
                      text="Pick-Up Location"
                      value={pickupValue}
                      inputValue={pickupInputValue}
                      // options={pickupOptions}
                      // setOptions={setPickupOptions}
                      onChange={(event, newValue) => {
                        handleChange(event, newValue, "pickUp");
                      }}
                      onInputChange={(event, newInputValue) => {
                        handleInputChange(event, newInputValue, "pickUp");
                      }}
                      placeholder="Address, Airport, Hotel, ..."
                      error={pickupError}
                      setShowMap={setShowMap}
                      setIsLoaded={setIsLoaded}
                      isLoaded={isLoaded}
                    />
                    {/* )} */}
                  </div>

                  {/* Second Row */}
                  <div>
                    <div
                      onClick={addStop}
                      className="label-form   font0 cursor-pointer"
                      style={{ width: "max-content" }}
                    >
                      <span className="main_color"> + Add Stop</span>
                      {!isPointToPointHire && hourlyMsg && (
                        <span className="stopErrorMsg">
                          Add atleast one Stop
                        </span>
                      )}
                      {isPointToPointHire && hourlyMsg && (
                        <span className="stopErrorMsg">3 Stops Allowed</span>
                      )}
                    </div>

                    {/* Add Stop Inputs */}
                    {addStopArray.map((stop, i) => {
                      return (
                        <div key={i}>
                          <div className="  grid grid-cols-5 gap-3">
                            <div className="  col-span-4">
                              <label
                                htmlFor={`add-stop-location-${i}`}
                                className="  label-form"
                              >
                                Stop Location
                              </label>
                              <div className=" ">
                                <LocationInputs
                                  key={i}
                                  text="Stop Location"
                                  id={`stop-location-${i}`}
                                  value={stop.location}
                                  inputValue={stop.inputValue}
                                  // options={stop.options}
                                  // setOptions={(newOptions) =>
                                  //   setStopOptionsAtIndex(newOptions, i)
                                  // }
                                  onChange={(event, newValue) =>
                                    handleChange(event, newValue, "stop", i)
                                  }
                                  onInputChange={(event, newInputValue) =>
                                    handleInputChange(
                                      event,
                                      newInputValue,
                                      "stop",
                                      i
                                    )
                                  }
                                  placeholder={`Stop Location`}
                                  error={stop.error}
                                />
                              </div>
                            </div>

                            <div className="col-span-1">
                              <span
                                className={`absolute ${
                                  isPointToPointHire ? "" : ""
                                }  mt-14 transform -translate-y-1/2 cursor-pointer`}
                                onClick={() => {
                                  // setShowMap(false);
                                  handleDeleteStop(i);
                                }}
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </span>
                            </div>
                          </div>
                          {isPointToPointHire === true && (
                            <div className=" pt-2 mb-2 flex text-xs ">
                              <div className="">
                                <Image
                                  src={Info}
                                  className="h-5"
                                  alt="Info-icon"
                                />
                              </div>
                              <div className="pt-0 ml-1">
                                15 minutes stop time is available. If the wait
                                time exceeds it will be charged accordingly.
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Third Row */}
                  {isPointToPointHire ? (
                    <div>
                      <label
                        htmlFor="dropoff-location"
                        className="block label-form fontsmall]"
                      >
                        Drop-off Location
                      </label>
                      {/* {!isLoaded ? (
                      <Skeleton
                        variant="rectangular"
                        height={56}
                        sx={{ borderRadius: 1 }}
                      />
                    ) : ( */}
                      <LocationInputs
                        id="dropoff-location"
                        text="Drop-off Location"
                        value={dropoffValue}
                        inputValue={dropoffInputValue}
                        // options={dropoffOptions}
                        // setOptions={setDropoffOptions}
                        onChange={(event, newValue) => {
                          handleChange(event, newValue, "dropOff");
                        }}
                        onInputChange={(event, newInputValue) => {
                          handleInputChange(event, newInputValue, "dropOff");
                        }}
                        placeholder="Address, Airport, Hotel, ..."
                        error={dropoffError}
                        setShowMap={setShowMap}
                        setIsLoaded={setIsLoaded}
                        isLoaded={isLoaded}
                      />
                      {/* )} */}
                    </div>
                  ) : (
                    <div>
                      <label
                        htmlFor=" SelectHours"
                        className="block label-form fontsmall]"
                      >
                        Select Hours
                      </label>
                      {!isLoaded ? (
                        // Show skeleton loader while the API is loading
                        <Skeleton
                          variant="rectangular"
                          height={56}
                          sx={{ borderRadius: 1 }}
                        />
                      ) : (
                        <Autocomplete
                          value={hour}
                          onChange={(event, newValue) => {
                            setHour(newValue);
                            if (typeof window !== "undefined") {
                              localStorage.setItem(
                                "hour",
                                JSON.stringify(newValue)
                              );
                            }
                          }}
                          inputValue={inputHour}
                          onInputChange={(event, newInputValue) => {
                            setInputHour(newInputValue);
                            if (typeof window !== "undefined") {
                              localStorage.setItem(
                                "inputHour",
                                JSON.stringify(newInputValue)
                              );
                            }
                          }}
                          id="controllable-states-demo"
                          options={Hours}
                          disableClearable
                          renderInput={(params) => (
                            <div style={{ position: "relative" }}>
                              <AccessTimeFilledIcon
                                color="gray"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: 10,
                                  color: "gray",
                                  transform: "translateY(-50%)",
                                }}
                              />
                              <TextField
                                {...params}
                                // label="Select Hours"
                                className="customAutocomplete"
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                  )}

                  {/* Fourth Row */}
                  <div className="grid gap-1.5  grid-cols-2">
                    <div>
                      <div
                        style={{ marginLeft: "1.9px" }}
                        className="grid grid-cols-1"
                      >
                        <label
                          htmlFor="pickUpDate" // Use only htmlFor in React
                          className="label-form"
                        >
                          Pick-Up Date
                        </label>
                        {!isLoaded ? (
                          // Show skeleton loader while the API is loading
                          <Skeleton
                            variant="rectangular"
                            height={56}
                            sx={{ borderRadius: 1 }}
                          />
                        ) : (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MuiDatePicker
                              minDate={minDate}
                              format="DD/MM/YYYY"
                              value={selectedDate}
                              onChange={handleDateChange}
                              open={isCalendarOpen}
                              onClose={() => setIsCalendarOpen(false)}
                              slotProps={{
                                textField: {
                                  id: "pickUpDate",
                                  helperText: dateError
                                    ? "Pick-up Date is required"
                                    : "",
                                  clearable: false,
                                  error: dateError,
                                  InputProps: {
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          onClick={() =>
                                            setIsCalendarOpen(true)
                                          }
                                          edge="end"
                                        >
                                          <EventIcon />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  },
                                  onClick: () => {
                                    setIsCalendarOpen(!isCalendarOpen);
                                  },
                                  onKeyDown: (e) => {
                                    e.preventDefault();
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        )}
                      </div>
                    </div>

                    <div className="">
                      <div className=" pl-1 grid grid-cols-1">
                        <label htmlFor="pick-upTime" className="label-form">
                          Pick-Up Time
                        </label>
                        {!isLoaded ? (
                          // Show skeleton loader while the API is loading
                          <Skeleton
                            variant="rectangular"
                            height={56}
                            sx={{ borderRadius: 1 }}
                          />
                        ) : (
                          <TimePicker
                            id="pick-upTime"
                            inputClick={inputClick}
                            setInputClick={setInputClick}
                            selectedHour={selectedHour}
                            setSelectedHour={setSelectedHour}
                            selectedMinute={selectedMinute}
                            setSelectedMinute={setSelectedMinute}
                            isAM={isAM}
                            setIsAM={setIsAM}
                            timeError={timeError}
                            type={"original"}
                          />
                        )}
                        {timeError === true && (
                          <div className="time-picker-style">
                            Pick-up Time is required
                          </div>
                        )}
                        {dateTimeMsg !== "" && (
                          <div className="time-picker-style">{dateTimeMsg}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="pt-0 text-[12px]  ">
                      Chauffeur will wait {waitTime} minutes as a complimentary
                      service
                    </div>

                    <div className=" mt-2 mb-3  flex justify-center border-gray-900/10 ">
                      {!isLoaded ? (
                        // Show skeleton loader while the API is loading
                        <Skeleton
                          variant="rectangular"
                          className="block w-full rounded-md px-3.5 py-2.5"
                          height={56}
                          sx={{
                            borderRadius: 1,
                            backgroundColor: "#BABABA",
                          }}
                        />
                      ) : (
                        <button
                          onClick={HandleSubmit}
                          type="submit"
                          className="block w-full rounded-md bgseconday    px-3.5 py-2.5 text-center text-Large font-semibold text-white  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          <span>
                            {" "}
                            {loading === true || loading === false ? (
                              <>
                                <BeatLoader size={10} color="#ffff" />
                              </>
                            ) : (
                              "Search"
                            )}{" "}
                          </span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default homepage;
